export const USERS_ROUTES = {
  __ROOT__: '/users',
  VIEW_USER: '/users/view/:userId',
}
